import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "store/location/action";
import PageHeading from "components/PageHeading";
import { Link } from "react-router-dom";

const Locations = ({ locations, locationsNextToken, listLocations }) => {

  useEffect(() => {
    if (!locations) {
      listLocations(1000, locationsNextToken);
    }
  }, []);

  if (!locations) {
    return (
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">Loading...</div>
    );
  }

  return (
    <React.Fragment>
      <PageHeading withCreate={true} />
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col">
          <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
              <table className="min-w-full">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      City, Country
                    </th>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Accepts Bookings
                    </th>
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {locations &&
                    locations.map((location, index) => (
                      <tr key= {index}>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                          {location.name}
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                          {location.address && location.address.postCode}{" "}
                          {location.address && location.address.city}{" "}
                          {location.address && location.address.country}
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                          <div className="ml-2 flex-shrink-0 flex">
                            {location.acceptsBookings ? (
                              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                Yes
                              </span>
                            ) : (
                              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                                No
                              </span>
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
                          <Link
                            to={`/location/${location.id}`}
                            className="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                          >
                            Edit
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    locations: state.location.list,
    locationsNextToken: state.location.listNextToken,
  };
};

const mapDispatchToProps = (dispatch) => ({
  listLocations: (limit, nextToken) =>
    dispatch(ACTIONS.getList(limit, nextToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Locations);
